/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "context";
import Icon from "@mui/material/Icon";
import EastIcon from "@mui/icons-material/East";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDProgress from "components/MDProgress";

// ENV Values
const apiUrl = process.env.REACT_APP_API_URL;

export default function deadlines({ mode = 0, admin = false }) {
  const { user } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch deadlines or events based on the admin flag
  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint = admin ? "user_events.php" : "dashboard/deadlines.php";
        const response = await fetch(`${apiUrl}/${endpoint}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: user.id,
            isAdmin: user.isAdmin || false,
            notificationsOnly: admin, // For admin, filter only unread notifications
          }),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        admin ? setEvents(result.events) : setData(result);
      } catch (error) {
        console.error("There was an error fetching the data!", error);
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      fetchData();
    }
  }, [user, admin]);

  // Define columns for regular users
  const getUserColumns = () => {
    const baseColumns = [
      {
        Header: "Evento",
        accessor: "event_name",
        align: "left",
        Cell: ({ row }) => (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <Link to={`/app/event/${row.original.event_id}`}>
              <MDTypography
                variant="button"
                fontWeight="medium"
                title={`${row.original.address_city} - ${row.original.event_name}`}
              >
                {`${row.original.address_city} - ${row.original.event_name}`.length > 25
                  ? `${`${row.original.address_city} - ${row.original.event_name}`.slice(0, 22)}...`
                  : `${row.original.address_city} - ${row.original.event_name}`}
              </MDTypography>
            </Link>
          </MDBox>
        ),
      },
      {
        Header: "Nome Documento",
        accessor: "document_name",
        align: "center",
      },
      {
        Header: "Azione",
        accessor: "document_type",
        align: "center",
        Cell: ({ row }) => (
          <MDTypography variant="caption" fontWeight="medium">
            {row.original.document_type === "Payment"
              ? "Payment Required"
              : row.original.document_type === "Sign"
              ? "Document To Sign"
              : "Document To Upload"}
          </MDTypography>
        ),
      },
      {
        Header: "Scadenza",
        accessor: "deadline",
        align: "center",
        Cell: ({ row }) => {
          const newDate = new Date(row.original.deadline);
          const formattedDate = `${String(newDate.getDate()).padStart(2, "0")}-${String(
            newDate.getMonth() + 1
          ).padStart(2, "0")}-${newDate.getFullYear()}`;
          const isPastDeadline = newDate < new Date();
          return (
            <MDTypography
              variant="caption"
              fontWeight="medium"
              color={isPastDeadline ? "error" : "text"}
            >
              {formattedDate}
            </MDTypography>
          );
        },
      },
      {
        Header: "",
        accessor: "event_id",
        align: "center",
        width: "3%",
        Cell: ({ row }) => (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <Link
              to={`/app/event/${row.original.event_id}/permission/${row.original.permission_id}`}
            >
              <EastIcon
                sx={{ fontSize: "2.5rem", fontWeight: "bold", transform: "scale(1.5)" }}
                color="primary"
              />
            </Link>
          </MDBox>
        ),
      },
    ];

    // Insert the "RESPONSABILE" column for admin users, after the first column
    if (user.isAdmin) {
      baseColumns.splice(1, 0, {
        Header: "RESPONSABILE",
        accessor: "admin_name",
        align: "center",
      });
    }

    return baseColumns;
  };

  // Define columns for admin users
  const getAdminColumns = () =>
    [
      {
        Header: "Eventi",
        accessor: "event_name",
        align: "left",
        Cell: ({ row }) => (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <Link to={`/app/event/${row.original.id}`}>
              <MDTypography
                variant="button"
                fontWeight="medium"
                title={`${row.original.address_city} - ${row.original.event_name}`}
              >
                {`${row.original.address_city} - ${row.original.event_name}`.length > 25
                  ? `${`${row.original.address_city} - ${row.original.event_name}`.slice(0, 22)}...`
                  : `${row.original.address_city} - ${row.original.event_name}`}
              </MDTypography>
            </Link>
          </MDBox>
        ),
      },
      user.isAdmin && {
        Header: "RESPONSABILE",
        accessor: "name",
        align: "center",
      },
      user.isAdmin && {
        Header: "Cliente",
        accessor: "company_name",
        align: "center",
      },
      mode === 0
        ? user.isAdmin && {
            Header: "Data di apertura",
            accessor: "created_date",
            align: "center",
            Cell: ({ row }) => {
              const newDate = new Date(row.original.created_date);
              const formattedDate = `${String(newDate.getDate()).padStart(2, "0")}-${String(
                newDate.getMonth() + 1
              ).padStart(2, "0")}-${newDate.getFullYear()}`;
              const isPastCreated = newDate.setDate(newDate.getDate() + 5) < new Date();
              return (
                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  color={isPastCreated ? "error" : "text"}
                >
                  {formattedDate}
                </MDTypography>
              );
            },
          }
        : {
            Header: "DATA EVENTO",
            accessor: "start_date",
            align: "center",
            Cell: ({ row }) => {
              const newDate = new Date(row.original.start_date);
              const formattedDate = `${String(newDate.getDate()).padStart(2, "0")}-${String(
                newDate.getMonth() + 1
              ).padStart(2, "0")}-${newDate.getFullYear()}`;
              const isPastStarted = newDate.setDate(newDate.getDate() - 5) < new Date();
              return (
                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  color={isPastStarted ? "error" : "text"}
                >
                  {formattedDate}
                </MDTypography>
              );
            },
          },
    ].filter(Boolean);

  // Generate rows for regular users
  const getUserRows = () => {
    let filteredData = data;
    if (mode === 1) {
      filteredData = data.filter((item) => item.document_type !== "Payment");
    } else if (mode === 2) {
      filteredData = data.filter((item) => item.document_type === "Payment");
    }

    return filteredData.map((doc) => ({
      id: doc.document_id,
      permission_id: doc.permission_id,
      event_id: doc.event_id,
      event_name: doc.event_name,
      admin_name: doc.admin_name ? `${doc.admin_name} ${doc.admin_surname}` : "N/A",
      address_city: doc.city,
      document_name: doc.document_name,
      document_type: doc.document_type,
      deadline: doc.expiry_date,
    }));
  };

  // Generate rows for admin users
  const getAdminRows = () => {
    let filteredData = events;
    if (mode === 0) {
      filteredData = events.filter((item) => item.status == "Attesa di valutazione");
    } else if (mode === 1) {
      filteredData = events.filter((item) => item.status === "In Emissione");
    }

    return filteredData.map((event) => ({
      id: event.id,
      event_name: event.event_name,
      address_city: event.address_city,
      name: event.admin_name ? `${event.admin_name} ${event.admin_surname}` : "NONE",
      company_name: event.company_name,
      start_date: event.start_date,
      created_date: event.created,
      progress: event.closedPermissions === event.totalPermissions ? "Completed" : "In Progress",
      status: event.status,
    }));
  };
  if (loading) {
    return { columns: [], rows: [], loading: true };
  }

  return {
    columns: admin ? getAdminColumns() : getUserColumns(),
    rows: admin ? getAdminRows() : getUserRows(),
    loading: false,
  };
}

